/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import WebpageEditContext from "components/webpage-selector/context";
import { AddWebpageButton } from "components/webpage-selector/add-webpage-button";
import { WebpageSelectorDisplayPanel } from "components/webpage-selector/display/display-panel";
import { exists, isTrue, isFalse, objectHasPropertyString } from "utils/empty-exists";

const WebpageSelectorDisplay = (props) => {
    
    const {
        AddComponent,
        DisplayComponent
    } = props;
    
    const {
        setOpen,
        webpage = "",
        onChange,
        onRemove
    } = useContext(WebpageEditContext);
    
    const hasDisplay = exists(DisplayComponent);
    const hasWebpage = objectHasPropertyString(webpage, "guid");

    return (
        <Fragment>
            {isTrue(hasWebpage)  &&
                <Fragment>
                    {isTrue(hasDisplay) &&
                        <Fragment>
                            <DisplayComponent
                                // this dynamic Component allows you to pass in your own React component as an add button
                                webpage={webpage}
                                setOpen={setOpen}
                                onChange={onChange}
                                onRemove={onRemove}
                                onClick={() => setOpen(true)}
                            />
                        </Fragment>
                    }
                    {isFalse(hasDisplay) &&
                        <WebpageSelectorDisplayPanel />
                    }
                </Fragment>
            }
            {isFalse(hasWebpage) &&
                <Fragment>
                    {AddComponent ? (
                        <AddComponent
                            // this dynamic Component allows you to pass in your own React component as an add button
                            webpage={webpage}
                            setOpen={setOpen}
                            onClick={() => setOpen(true)}
                        />
                    ) : (
                        <AddWebpageButton setOpen={setOpen} />
                    )}
                </Fragment>
            }
        </Fragment>
    );
};

export { WebpageSelectorDisplay };
